import { Brain, Undo2, History, Tag, Wallet } from "lucide-react";

const CAT_LABELS = {
  materials: "Materials",
  equipment: "Tools & Equipment",
  vehicle: "Fuel & Vehicle",
  subcontractor: "Subcontractor",
  site: "Site Costs",
  safety: "PPE & Safety",
  admin: "Admin & Office",
  travel: "Meals & Travel",
};

export default function TwinInsightsCard({ twin, form, onUndo }) {
  const rows = [];
  if (twin.deduction_category)
    rows.push({
      icon: Tag,
      label: "Deduction category",
      value: CAT_LABELS[twin.deduction_category] || twin.deduction_category,
      key: "deduction_category",
    });
  if (twin.category) rows.push({ icon: Tag, label: "Tag", value: twin.category, key: "category" });
  if (twin.cost_code) rows.push({ icon: Tag, label: "Cost code", value: twin.cost_code, key: "cost_code" });
  if (twin.avg_total > 0)
    rows.push({
      icon: Wallet,
      label: "Average total",
      value: `$${Number(twin.avg_total).toFixed(2)}`,
      key: "avg_total",
    });
  const filled = new Set(twin.filled || []);
  const hasFilled = filled.size > 0;

  return (
    <div className="bi-surface p-4 relative overflow-hidden" data-testid="rv-twin-insights">
      <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full blur-3xl opacity-15 bg-[#34D399]" />
      <div className="relative flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-[#34D399]/15 text-[#34D399] shrink-0">
          <Brain className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/50 font-heading">Supplier Twin</div>
            <span className="text-[10px] px-2 py-0.5 rounded-full border border-[#34D399]/40 bg-[#34D399]/10 text-[#34D399] inline-flex items-center gap-1">
              <History className="w-3 h-3" /> {twin.history_count} past{" "}
              {twin.history_count === 1 ? "entry" : "entries"}
            </span>
          </div>
          <div className="mt-1 text-sm text-white/90 leading-snug">
            <b className="text-white">{twin.matched_supplier}</b>{" "}
            {twin.deduction_category ? (
              <>
                usually goes to{" "}
                <b style={{ color: "#FF9500" }}>
                  {CAT_LABELS[twin.deduction_category] || twin.deduction_category}
                </b>
                {twin.avg_total > 0 && (
                  <>
                    {" "}
                    · avg <b>${Number(twin.avg_total).toFixed(2)}</b>
                  </>
                )}
                .
              </>
            ) : (
              <>
                has {twin.history_count} past {twin.history_count === 1 ? "entry" : "entries"}.
              </>
            )}
          </div>
          <div className="mt-3 space-y-1.5">
            {rows.map((r) => {
              const wasFilled = filled.has(r.key);
              const current = String(form[r.key] || "").trim();
              const matchesTwin =
                r.key === "avg_total"
                  ? true
                  : current.toLowerCase() === String(twin[r.key] || "").toLowerCase();
              return (
                <div key={r.key} className="flex items-center gap-2 text-xs">
                  <r.icon
                    className={`w-3.5 h-3.5 shrink-0 ${
                      wasFilled ? "text-[#34D399]" : "text-white/40"
                    }`}
                  />
                  <span className="text-white/60 w-32 shrink-0">{r.label}</span>
                  <span
                    className={`font-medium ${
                      wasFilled ? "text-[#34D399]" : matchesTwin ? "text-white" : "text-white/70"
                    }`}
                  >
                    {r.value}
                  </span>
                  {wasFilled && (
                    <span className="text-[9px] uppercase tracking-wider text-[#34D399]/80 ml-auto">
                      Auto-filled
                    </span>
                  )}
                </div>
              );
            })}
          </div>
          {hasFilled && (
            <button
              type="button"
              onClick={onUndo}
              data-testid="rv-twin-undo"
              className="mt-3 h-9 px-3 rounded-lg bi-ghost-btn text-xs inline-flex items-center gap-1.5"
            >
              <Undo2 className="w-3.5 h-3.5" /> Undo Twin fill
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
